export default {"src":"/_next/static/media/building.82582e64.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};